import type { DiagramHost } from '../diagram/host.js';
import { WorkspaceCommand, DockableToolbar, DockSlot, useToolbarDragging } from '../components/WorkspaceTools';
import { EntityDisplayControls } from '../components/AppearanceControls';
/** These are the existing component and hook identities, not per-render wrappers. */
export const diagramHost: DiagramHost = {
  Command: WorkspaceCommand, Toolbar: DockableToolbar, Slot: DockSlot,
  useDragging: useToolbarDragging, EntityDisplayControls,
};
